/*eslint-disable */
import { bus } from "@/main"
export default {
  name: 'chat-for-user-suggestion-list',
  components: {},
  props: ['selectedGroupID','messageContentDraftVAL', 'value'],
  data () {
    return {
      getUserNameListData:null,
      getUserNameListResults:[],
      userNameListResults:[],
      serachNameVal:'',
      team:{
        handle:'team'
      }
    }
  },
  computed: {
    getUserNameListFromGroupMethod(){
      return this.$store.getters.getUserNameListFromGroupGetters
    }
  },
  created () {
    this.$store.dispatch('getUserNameListFromGroupAction', {id:this.selectedGroupID})
  },
  methods: {
    selectedSuggestedUserInfo(data){
      this.value.handle = data.handle + ' '
      bus.$emit('suggestionUserListStateForFileAttachBus', false)
      bus.$emit('suggestionUserListStateBus', false)
    },
    searchValMatchInArray(value){
      let valueSpilt = value.split('@').slice(-1)
      let valueLower = valueSpilt[0].toLowerCase()
      let list = document.querySelectorAll(".suggestion_user_list_item li");
      for(let i = 0; i < list.length; i += 1){
        if(list[i].dataset.attr.toLowerCase().includes(valueLower)){
          list[i].style.display = "block";
        }else{
          list[i].style.display = "none";
        }
      }
      // this.getUserNameListResults.filter(item => {
      //   let uFullName = '@' + item.first_name + ' ' + item.last_name;
      //   if(uFullName.toLowerCase().includes(value.toLowerCase())){
      //     console.log("TRUE EVENT")
      //     let list = document.querySelectorAll(".suggestion_user_list_item li");
      //     for(let i = 0; i < list.length; i += 1){
      //       if(list[i].dataset.attr.toLowerCase().includes(value.toLowerCase())){
      //         list[i].style.display = "block";
      //       }else{
      //         list[i].style.display = "none";
      //       }
      //     }
      //   }else{
      //     console.log("FALSE EVENT")
      //     bus.$emit('suggestionUserListStateBus', false)
      //   }
      // });
    }
  },
  watch:{
    getUserNameListFromGroupMethod(newVal, oldVal){
      this.getUserNameListData = newVal
      this.getUserNameListResults = this.getUserNameListData.data
    },
    messageContentDraftVAL(newVal, oldVal){
      this.serachNameVal = newVal
      this.searchValMatchInArray(this.serachNameVal)
    }
  }
}